<div class="close-button" [mat-dialog-close]="true">
</div>
<iframe [src]="cleanURL(url)" width="100%" height="100%" class="privacy-iframe">Privacy Policy</iframe>